import { TimeIntervalEnum } from '../../../shared/enums/time-interval.enum';

/**
 * Interface representing the options for vehicle insurance reminders.
 */
export class VehicleInsurancesReminderOptions {
	/**
	 * Flag indicating if reminders are enabled
	 * @description If false, no reminders will be sent regardless of other settings.
	 */
	enabled!: boolean;

	/**
	 * Time interval before the vehicle insurance ends to send a reminder
	 * @description If set, a reminder will be sent this long before the end date.
	 */
	beforeEndsAt?: TimeIntervalEnum;

	/**
	 * Time interval after the vehicle insurance ended to send a reminder if the status of the record is still
	 * not completed.
	 * @description If set, a reminder will be sent this long after the end date if the record is overdue.
	 */
	afterEndsAtOverdue?: TimeIntervalEnum;
}
